import IPlugin from "./plugin";
import Vuex from "vuex";
import stores from "../stores";

export default class StorePlugin extends IPlugin {
    setup(Vue, config) {
        Vue.use(Vuex);
        config.store = new Vuex.Store(stores);
        return super.setup(Vue, config);
    }
}